module.exports = __webpack_public_path__ + "img/ja-jp.6f7f9f72.png";